import { toast } from "@picklebet/ui";
import { parseError } from "utilities/errorsParser";
import { triggerHaptic } from "@/utilities/haptics";
import type { Alert } from "@/features/betslip/types";
import type { BetslipStoreHandle } from "@/features/betslip/services/submitBet/types";

const TIMED_OUT_FRAGMENT = "Timed out waiting for a response";

export const transportErrorAlert = (
  variant: Alert["variant"],
  message: string,
): Alert => ({
  variant,
  message,
  cta: { label: "Got It", action: "dismissTransportError" },
});

/**
 * Surface a transport failure. Timeouts land as an in-slip alert with
 * the "check Pending tab" copy; everything else (network, payload size,
 * etc.) goes to a global toast so the slip stays clean for retry.
 */
export const reportTransportError = (
  store: ReturnType<BetslipStoreHandle["getState"]>,
  error: { message?: string } | null | undefined,
): void => {
  triggerHaptic.error();
  const message = error?.message ?? "";
  if (message.includes(TIMED_OUT_FRAGMENT)) {
    store.setTransportError(
      transportErrorAlert(
        "danger",
        "Bet request timed out. Confirm bet placement in your Pending tab",
      ),
    );
    return;
  }
  // Surface the backend's own error detail — support diagnoses failed
  // placements from what the user sees in this toast.
  toast({
    title: "Error placing bet",
    variant: "danger",
    description: parseError(error),
  });
};
